export const SPECIAL_CHARS = '-+_!§#$';

export const PASSWORD_RULES_TEXT =
  'Mindestens 8 Zeichen. Erlaubt: A–Z, a–z, 0–9 und eines der Sonderzeichen - + _ ! § # $. ' +
  'Erforderlich: ein Buchstabe oder Unterstrich, ein Sonderzeichen und eine Ziffer.';

/** Liefert eine Fehlermeldung oder null, wenn das Passwort gültig ist. */
export function validatePassword(pw: string): string | null {
  if (pw.length < 8) return 'Das Passwort muss mindestens 8 Zeichen lang sein.';
  if (!/^[A-Za-z0-9\-+_!§#$]+$/.test(pw)) {
    return 'Das Passwort enthält nicht erlaubte Zeichen (erlaubt: A–Z, a–z, 0–9 und - + _ ! § # $).';
  }
  if (!/[A-Za-z_]/.test(pw)) return 'Das Passwort braucht mindestens einen Buchstaben oder Unterstrich.';
  if (!/[-+_!§#$]/.test(pw)) return 'Das Passwort braucht mindestens ein Sonderzeichen (- + _ ! § # $).';
  if (!/[0-9]/.test(pw)) return 'Das Passwort braucht mindestens eine Ziffer.';
  return null;
}
